module.exports = __webpack_public_path__ + "img/silver.b4351998.svg";